/* IMPORT HERE */

import { ThemeUICSSObject } from 'theme-ui';
import { focusOutline } from '../../../../util';

const autocomplete: ThemeUICSSObject = {
  '&:focus-within': focusOutline,
  background: 'palette.background.paper',

  '.autocomplete__inputWrapper': {
    position: 'relative',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    width: '100%',
    minWidth: 0,
    border: ' 1px solid',
    borderColor: 'palette.border.field',
    p: '2px',
    borderRadius: 'default',
    '& > div': {
      minWidth: 0,
      width: '100%',
    },
    input: {
      border: 'none',
      outline: 'none!important',
      height: '46px',
    },
  },

  '.autocomplete__search': {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },

  '.autocomplete__search.disabled': {
    cursor: 'not-allowed',
    background: 'form.fields.disabled.backgroundColor',
    borderColor: 'form.fields.disabled.backgroundColor',
  },
  '.autocomplete__search.readOnly': {
    background: 'form.fields.readonly.backgroundColor',
    borderColor: 'form.fields.readonly.backgroundColor',
  },
  '.autocomplete__icons': {
    alignItems: 'center',
    display: 'flex',
    gap: 2,
    height: '24px',
    right: '20px',
    top: 'calc(50% - 12px)',
    pointerEvents: 'none',
    pr: 4,
    maxWidth: '30px',

    '.autocomplete__loadingSpinner': {
      width: '24px',
      height: '24px',
    },

    '.autocomplete__downArrow': {
      cursor: 'pointer',
      height: '12px',
      pointerEvents: 'none',
      width: '12px',
    },
  },

  optionsContainer: {
    background: 'palette.background.paper',
    border: '1px solid',
    borderColor: 'palette.border.field',
    '&.autocomplete__options__box': {
      background: 'palette.background.paper',
      border: '1px solid',
      borderColor: 'palette.border.field',
      zIndex: 'tooltip',
      overflow: 'auto',
      display: 'block',
      width: 'min-content',
    },

    '.autocomplete__option': {
      variant: 'buttons.link',
      border: 'none',
      textDecoration: 'none',
      transition: 'unset',

      '&.readOnly': {
        background: 'form.fields.readonly.backgroundColor',
        borderColor: 'form.fields.readonly.backgroundColor',
        color: 'palette.text.primary',
        cursor: 'not-allowed',
      },

      '&.focused, &:hover': (theme) =>
        theme.palette.getOneState(
          {
            backgroundColor: theme.palette.background.paper,
            color: theme.palette.text.primary,
          },
          'selected',
        ),
    },
  },
};

export default autocomplete;
